// src/App/Pages/Casino/SingleVendorPage.js
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { BRAND } from "../../../Helper";
import VendorGamesComponent from "../../Components/singleVendor";

/* ============= Styled Components ============= */

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #0a0e17;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const HeaderSection = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  background-color: #1c1e22;
  border-radius: 15px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
    padding: 15px;
  }
`;

const VendorTitle = styled.h1`
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const VendorDescription = styled.p`
  color: #7f898c;
  font-size: 16px;
  margin: 10px 0 0 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const BackButton = styled.button`
  background-color: #03030f;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #4a5354;
  }
`;

const ContentWrapper = styled.div`
  background-color: #1c1e22;
  padding: 20px;
  border-radius: 15px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

/* ============= Main Functional Component ============= */

const SingleVendorPage = ({ VENDOR_CONFIG }) => {
  const { vendorId = "pragmatic" } = useParams();
  const history = useHistory();

  const [vendorConfig, setVendorConfig] = useState(
    VENDOR_CONFIG[vendorId] || VENDOR_CONFIG.pragmatic
  );

  // On mount + vendor change
  useEffect(() => {
    setVendorConfig(VENDOR_CONFIG[vendorId] || VENDOR_CONFIG.pragmatic);
    window.scrollTo(0, 0);
  }, [vendorId]);

  const handleBack = () => history.goBack();

  return (
    <>
      <Helmet>
        <title>{BRAND} - {vendorConfig.displayName} | Casino Games</title>
        <meta
          name="description"
          content={`Play ${vendorConfig.displayName} games at ${BRAND}. ${vendorConfig.description}`}
        />
        <meta
          name="keywords"
          content={`${vendorConfig.displayName}, Casino Games, Online Casino, ${BRAND}`}
        />
      </Helmet>

      <PageContainer>
        <BackButton onClick={handleBack}>← Back to Casino</BackButton>

        <HeaderSection>
          <VendorTitle>{vendorConfig.displayName}</VendorTitle>
          <VendorDescription>{vendorConfig.description}</VendorDescription>
        </HeaderSection>

        <ContentWrapper>
          <VendorGamesComponent
            vendorId={vendorId}
            displayName={vendorConfig.displayName}
          />
        </ContentWrapper>
      </PageContainer>
    </>
  );
};

export default SingleVendorPage;
